<template>
  <v-dialog width="500" v-model="opened">
    <v-card>
      <AuthForm @close="opened = false" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AuthModal",
  data() {
    return {
      opened: false,
    };
  },
  mounted() {
    this.$root.$on("auth", async (value = true) => {
      this.opened = value;
    });
  },
};
</script>

<style></style>
